import { createContext, useContext, type ReactNode } from 'react';
import type { BuilderApiAdapter } from '../types/api.types';

const BuilderApiContext = createContext<BuilderApiAdapter | null>(null);

interface BuilderApiProviderProps {
  api: BuilderApiAdapter;
  children: ReactNode;
}

export const BuilderApiProvider = ({
  api,
  children,
}: BuilderApiProviderProps) => (
  <BuilderApiContext.Provider value={api}>
    {children}
  </BuilderApiContext.Provider>
);

export const useBuilderApi = (): BuilderApiAdapter => {
  const api = useContext(BuilderApiContext);
  if (!api)
    throw new Error('useBuilderApi must be used within DesignBuilder');
  return api;
};
